import { exportGetLoansByCriteria, Filter, FilterOperator, getLoansByCriteria } from '@nemuru-eng/js-api-client';

import { ApplicationTypeMap } from '@/config/maps/ApplicationType.map';
import { ApplicationType } from '@/config/types';
import { exportXLSX } from '@/utils/exportXLSX';
import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useFetchLoanList({
  applicationType,
  additionalFilters,
}: {
  applicationType: ApplicationType;
  additionalFilters?: Filter[];
}) {
  const queryAdditionalFilters = additionalFilters ?? [];
  const baseQueryFilters: Filter[] = [
    {
      field: 'asset_type',
      operator: FilterOperator.IN,
      value: ApplicationTypeMap.toAssetTypes(applicationType).join(','),
    },
    ...queryAdditionalFilters,
  ];

  const fetchLoanList = async (query) => {
    const customFilters = baseQueryFilters.concat(query?.filters);
    const dataTransform = (result) => ({ ...result, data: result.data });
    return fetchForDataGrid(getLoansByCriteria, { ...query, filters: customFilters }, dataTransform);
  };

  const fetchXLSXExport = (query) => {
    const customFilters = baseQueryFilters.concat(query?.filters);
    return exportXLSX(exportGetLoansByCriteria, { ...query, filters: customFilters });
  };

  return { fetchLoanList, fetchXLSXExport };
}
